<div class="nin-verification-modal">
  @if (step === 'details') {
    <h1 class="kyc-details">Identity Verification</h1>
    <p class="kyc-subtitle">
      One-time identity re-verification required. Confirm your NIN to continue using your account — you'll only need to
      do this once.
    </p>
    <form [formGroup]="form" class="row justify-content-between has-validation">
      <div class="col-md-6 mb-4">
        <label for="nin" class="form-label">NIN</label>
        <input formControlName="nin" id="nin" type="number" inputmode="numeric"
          [ngClass]="{ 'is-invalid': showError('nin') }" class="form-control" placeholder="Enter your 11-digit NIN" />
        @if (showError('nin')) {
          <div class="invalid-feedback">
            @if (form.get('nin')?.hasError('required')) {
              <span>
                Please enter your NIN.
              </span>
            }
            @if (form.get('nin')?.hasError('pattern')) {
              <span>
                NIN must be exactly 11 digits.
              </span>
            }
          </div>
        }
      </div>
      <div class="col-md-6 mb-4">
        <label for="phoneNumber" class="form-label">Phone Number</label>
        <input formControlName="phoneNumber" [ngClass]="{ 'is-invalid': showError('phoneNumber') }" id="phoneNumber"
          type="text" class="form-control" placeholder="e.g. 08012345678" />
        @if (showError('phoneNumber')) {
          <div class="invalid-feedback">
            @if (form.get('phoneNumber')?.hasError('required')) {
              <span>
                Please enter your phone number.
              </span>
            }
            @if (form.get('phoneNumber')?.hasError('pattern')) {
              <span>
                Please enter a valid Nigerian phone number.
              </span>
            }
          </div>
        }
      </div>
    </form>
    <div class="d-grid justify-content-center gap-2">
      <button type="button" (click)="onVerify()" [disabled]="isSubmitting" class="btn prjct-btn-square">
        @if (isSubmitting) {
          <span>Verifying...</span>
        }
        @if (!isSubmitting) {
          <span>Verify Identity</span>
        }
      </button>
    </div>
  }

  @if (step === 'otp') {
    <h1 class="kyc-details">Enter OTP</h1>
    <p class="kyc-subtitle">
      An OTP has been sent to
      <strong>{{ form.get('phoneNumber')?.value }}</strong>. Enter it below to complete your verification.
    </p>
    <form [formGroup]="otpForm" class="row justify-content-center has-validation">
      <div class="col-md-6 mb-4">
        <label for="otp" class="form-label">OTP</label>
        <input formControlName="otp" id="otp" type="text" inputmode="numeric" maxlength="6"
          [ngClass]="{ 'is-invalid': showOtpError() }" class="form-control" placeholder="Enter the 6-digit OTP" />
        @if (showOtpError()) {
          <div class="invalid-feedback">
            @if (otpForm.get('otp')?.hasError('required')) {
              <span>
                Please enter the OTP sent to your phone.
              </span>
            }
            @if (otpForm.get('otp')?.hasError('pattern')) {
              <span>
                OTP must be exactly 6 digits.
              </span>
            }
          </div>
        }
      </div>
    </form>
    <div class="otp-info" role="note">
      <svg class="otp-info__icon" width="18" height="18" viewBox="0 0 24 24" fill="none"
        xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2" />
        <path d="M12 11v5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        <circle cx="12" cy="7.75" r="1.25" fill="currentColor" />
      </svg>
      <span class="otp-info__text">
        Not receiving your OTP? Please ensure you have allowed us to send you
        messages. If you have DND (Do Not Disturb) active on your line, text
        <strong>ALLOW</strong> to <strong>2442</strong> to opt in, then tap
        Resend OTP.
      </span>
    </div>
    <div class="d-grid justify-content-center gap-2">
      <button type="button" (click)="onVerifyOtp()" [disabled]="isSubmitting" class="btn prjct-btn-square">
        @if (isSubmitting) {
          <span>Verifying...</span>
        }
        @if (!isSubmitting) {
          <span>Verify OTP</span>
        }
      </button>
      <button type="button" (click)="onResendOtp()" [disabled]="isResending || isSubmitting" class="btn btn-link">
        @if (isResending) {
          <span>Resending...</span>
        }
        @if (!isResending) {
          <span>Resend OTP</span>
        }
      </button>
      <button type="button" (click)="onBackToDetails()" [disabled]="isSubmitting" class="btn btn-link">
        Change details
      </button>
    </div>
  }
</div>